import {
  DisplayableError,
  useDisplayableError,
} from "kreate-common/modules/displayable-error";
import {
  getResourceKey$GetSecondaryHighlight,
  httpGet$GetSecondaryHighlight,
} from "kreate-server/commands/GetSecondaryHighlight/fetcher";
import { GetSecondaryHighlight$Result } from "kreate-server/commands/GetSecondaryHighlight/typing";
import useSWR from "swr";

export default function useSecondaryHighlight(): [
  GetSecondaryHighlight$Result | undefined,
  DisplayableError | undefined
] {
  const { data, error } = useSWR(
    getResourceKey$GetSecondaryHighlight(),
    async () =>
      await httpGet$GetSecondaryHighlight("api/v1/secondary-page/highlight")
  );
  const displayableError = useDisplayableError(error);
  return [data, displayableError];
}
